<template>
    <form v-on:submit.prevent="click" v-if="keyword">

        <div class="row">
            <div class="col-md-12">
                <!-- Custom Tabs -->
                <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                        <li class="active">
                            <a href="#tab_1" data-toggle="tab">Generali</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" id="tab_1">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="nome">Nome</label>
                                                <input type="text" class="form-control" id="nome"
                                                       name="nome"
                                                       v-model="keyword.keyword" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- /.tab-pane -->

                    </div>
                    <!-- /.tab-content -->

                    <div class="box-footer">
                        <div class="row">
                            <div class="col-md-2 col-md-offset-10">
                                <button class="btn btn-success btn-block" v-if="!disabled">
                                    <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                                    Salva
                                </button>

                                <button class="btn btn-warning btn-block" v-on:click.prevent="activateMod"
                                        v-if="disabled">
                                    Attiva modifiche
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- nav-tabs-custom -->
            </div>
        </div>

    </form>
</template>

<script>
  import { clientDateFormat } from '../../filters'
  import keywordsApi from '../../api/keywords'

  export default {
    props: ['disabled', 'keyword', 'loader', 'showLabels'],
    methods: {
      click () {
        this.$emit('click', this.keyword)
      },
      error (e) {
        console.log(e)
      },
      activateMod () {
        this.$emit('activate-mod', this.keyword)
      }
    },
    data () {
      return {
        config: {
          format: clientDateFormat
        },
        keywords: []
      }
    },
    computed: {
      donazione_tipi () {
        return this.$store.state.decoder.decoders['_dDonationTypes']
      }
    },
    beforeCreate () {
      keywordsApi.index()
        .then((response) => {
          this.keywords = response.data.data
        })
    },
    components: {}
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/keywords/Form.vue